import { render, staticRenderFns } from "./ContractItem.vue?vue&type=template&id=65a48687&"
import script from "./ContractItem.vue?vue&type=script&lang=js&"
export * from "./ContractItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports